import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth/index';
import dealers from './modules/dealers/index';
import users from './modules/users/index';
import plates from './modules/plates/index';
import settings from './modules/settings/index';
import logs from './modules/logs/index';
import myStock from './modules/my-stock/index';
import stockSupplyDemand from './modules/stock-supply-demand/index';
import stockOffer from './modules/offer/index';
import stockDemand from './modules/demand/index';
import stockFilter from './modules/stock-filter/index';

Vue.use(Vuex);

const modules = {
  auth,
  users,
  dealers,
  settings,
  plates,
  logs,
  myStock,
  stockSupplyDemand,
  stockOffer,
  stockDemand,
  stockFilter,
};

export default new Vuex.Store({
  modules,
});
